export { default } from './Avatar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Avatar/index.js
// module id = 175
// module chunks = 0